// extracted by mini-css-extract-plugin
export default {"primary":"Header_primary__lanVP","carrinho":"Header_carrinho__F40Yl"};